import { useEffect, useState } from "react";
import type { Role, User } from "@/lib/users.api";
import { useIsMobile } from "@/hooks/useIsMobile";
import type { UsersPageViewMode } from "../usersPage.constants";

export function useUsersPageState() {
  const [search, setSearch] = useState("");
  const [roleFilter, setRoleFilter] = useState<Role | "">("");
  const [editing, setEditing] = useState<User | null>(null);
  const [viewMode, setViewMode] = useState<UsersPageViewMode>("table");
  const isMobile = useIsMobile();

  useEffect(() => {
    if (isMobile) setViewMode("grid");
  }, [isMobile]);

  return {
    search,
    setSearch,
    roleFilter,
    setRoleFilter,
    editing,
    setEditing,
    viewMode,
    setViewMode,
  };
}
